



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
    RecentCard,
    RecentCardsHelper
} from "@/core/helpers/RecentCardsHelper";
import { InsuranceCard } from "@/services/index.defs";
@Component
export default class RecentCalcs extends Vue {
    created() {
        this.recentCards = RecentCardsHelper.getCards();
        if (this.recentCards.length == 0) this.$emit("hide");
    }

    removeCalcs() {
        RecentCardsHelper.clear();
        this.$emit("hide");
    }

    recentCards: RecentCard[] = [];

    async setCard(card: InsuranceCard) {
        if (card.car?.markId) card.car.markId = card.car.markId + ""; // prev version card guard
        if (card.car?.modelId) card.car.modelId = card.car.modelId + ""; // those were numbers before new osago
        if (card.car?.markId) {
            this.$store.direct.dispatch.dicti.getMapModels(card.car.markId);
            await this.$store.direct.dispatch.dicti.getModifications(
                card.car.modelId
            );
            if (
                card.car.modificationId &&
                !this.$store.direct.state.dicti.modifications.find(
                    x => x.id == card.car.modificationId
                )
            ) // if modificationId exists, but there are no such modification
                console.log("setting new modification based on car parameters")
            card.car.modificationId =
                    this.$store.direct.state.dicti.modifications.find(
                        x =>
                            x.power == card.car.power &&
                            x.manufactureStart <= card.car.yearIssue &&
                            x.manufactureEnd >= card.car.yearIssue
                    )?.id ?? null;
        }
        this.$store.direct.commit.insurance.setCard(card);
        this.$store.state.ratelimitVisible = false;
        if (!card.car.licensePlate) {
            this.$store.direct.state.widget.gosSignOn = false;
        }
        this.$nextTick(() => {
            this.scrollToTop();
            this.$emit("hide");
        });
    }
    scrollToTop() {
        window.parent.postMessage("scrollUp", "*");
    }
}
